import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, switchMap, take, filter } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';
import * as AuthActions from 'src/storage/auth/auth.actions';
import { selectValidToken, selectIsTokenValid, selectAuthLoading } from 'src/storage/auth/auth.selectors';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private sessionId = '';
  GENERAL_CLIENT_ID = environment.GENERAL_CLIENT_ID;
  constructor(private store: Store) {}

  public setSessionId(id: string): void {
    this.sessionId = id;
  }

  public getSessionId(): string {
    return this.sessionId;
  }

  /**
   * Obtiene un token válido desde el store o solicita uno nuevo si es necesario
   */
  private getValidToken(): Observable<string> {
    return this.store.select(selectValidToken).pipe(
      take(1),
      switchMap(token => {
        if (token) {
          // Token válido existe, lo devolvemos
          return of(token.access_token);
        } else {
          // No hay token válido, solicitar uno nuevo
          this.store.dispatch(AuthActions.loadToken());
          
          // Esperar a que se complete la carga del token
          return this.store.select(selectValidToken).pipe(
            filter(newToken => newToken !== null),
            take(1),
            map(newToken => newToken!.access_token)
          );
        }
      })
    );
  }

  /**
   * Crea headers con token de autorización, 
   * se añade client_id y session_id para cumplir con requisitos de seguridad.
   */
  createAuthHeaders(): Observable<HttpHeaders> {
    return this.getValidToken().pipe(
      map(token => {
        return new HttpHeaders({
          'Accept': '*/*',
          'Authorization': `Bearer ${token}`,
          'client_id': this.GENERAL_CLIENT_ID,
          'session_id': this.sessionId,
        });
      })
    );
  }

  /**
   * Verifica si el token actual es válido
   */
  isTokenValid(): Observable<boolean> {
    return this.store.select(selectIsTokenValid);
  }

  /**
   * Fuerza la renovación del token
   */
  refreshToken(): void {
    this.store.dispatch(AuthActions.loadToken());
  }

  /**
   * Limpia el token del store
   */
  clearToken(): void {
    this.store.dispatch(AuthActions.clearToken());
  }
}